import React, { useEffect, useMemo, useState } from "react";
import { Paper, Typography } from "@material-ui/core";

const LOTE_INICIAL = 30;
const LOTE_INCREMENTO = 30;

const formatHora = (date) => {
  if (!date) return "";
  return new Date(date).toLocaleString("es-MX");
};

const formatValorNuevo = (data) => {
  if (data === null || data === undefined) return "";
  if (typeof data === "object") {
    const entries = Object.entries(data);
    if (entries.length === 1 && typeof entries[0][1] !== "object") {
      // Se muestra "campo: valor" para saber sobre qué atributo fue el
      // cambio, incluso cuando el valor por sí solo (ej. "true") no lo dice.
      const [campo, valor] = entries[0];
      return campo + ": " + String(valor);
    }
    return JSON.stringify(data);
  }
  return String(data);
};

const resolverUsuario = (eventOrganizers, userId) => {
  if (!userId) return "NA";
  const organizador = eventOrganizers && eventOrganizers[userId];
  if (!organizador) return userId;
  return organizador.nombre || organizador.correo || userId;
};

// Filas compactas: menos padding vertical que el default de la tabla
// "striped". Hora y Usuario van sin salto de línea, dándoles el ancho que
// necesiten para caber en una sola fila (el resto de las columnas sí puede
// envolver texto normalmente).
const celdaCompacta = { padding: "3px 10px" };
const celdaSinSalto = { ...celdaCompacta, whiteSpace: "nowrap" };

const EventLogsList = ({ eventLogs, eventOrganizers }) => {
  const [mostrados, setMostrados] = useState(LOTE_INICIAL);

  const logsOrdenados = useMemo(() => {
    if (!eventLogs) return [];
    return Object.keys(eventLogs)
      .map((key) => ({ id: key, ...eventLogs[key] }))
      .sort((a, b) => b.date - a.date);
  }, [eventLogs]);

  useEffect(() => {
    const handleScroll = (event) => {
      const target =
        event.target === document ? document.documentElement : event.target;
      const scrollTop = target.scrollTop || window.scrollY;
      const scrollHeight = target.scrollHeight || document.documentElement.scrollHeight;
      const clientHeight = target.clientHeight || window.innerHeight;

      const alFinal = scrollTop + clientHeight >= scrollHeight - 200;
      if (alFinal) {
        setMostrados((prev) =>
          Math.min(prev + LOTE_INCREMENTO, logsOrdenados.length)
        );
      }
    };
    // useCapture=true: el scroll puede ocurrir dentro de un contenedor
    // anidado con su propio overflow, no en window. El scroll no hace
    // bubbling, pero sí se puede capturar desde un ancestro con "true".
    window.addEventListener("scroll", handleScroll, true);
    return () => window.removeEventListener("scroll", handleScroll, true);
  }, [logsOrdenados.length]);

  const logsVisibles = logsOrdenados.slice(0, mostrados);

  return (
    <Paper style={{ margin: 5, padding: 20 }}>
      <Typography variant={"h3"} align="left">
        Logs del sistema
      </Typography>
      <Typography variant={"subtitle1"} align="left" gutterBottom>
        Mostrando {logsVisibles.length} de {logsOrdenados.length}
      </Typography>

      <table className="striped">
        <thead>
          <tr>
            <th style={celdaSinSalto}>Hora</th>
            <th style={celdaSinSalto}>Usuario</th>
            <th style={celdaCompacta}>Ruta</th>
            <th style={celdaCompacta}>Valor nuevo</th>
          </tr>
        </thead>
        <tbody>
          {logsVisibles.map((log) => (
            <tr key={log.id}>
              <td style={celdaSinSalto}>{formatHora(log.date)}</td>
              <td style={celdaSinSalto}>
                {resolverUsuario(eventOrganizers, log.userIdCreate)}
              </td>
              <td style={celdaCompacta}>{log.route}</td>
              <td style={celdaCompacta}>{formatValorNuevo(log.data)}</td>
            </tr>
          ))}
          {logsOrdenados.length === 0 && (
            <tr>
              <td colSpan={4} style={{ textAlign: "center" }}>
                No hay logs registrados para este evento
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </Paper>
  );
};

export default EventLogsList;
